import { ReactComponent as GithubIcon } from '../assets/icons/github-icon.svg';
import { ReactComponent as GitlabIcon } from '../assets/icons/gitlab-onboarding-icon.svg';
import { ReactComponent as AzureIcon } from '../assets/icons/azure-icon.svg';
import { ReactComponent as BitbucketIcon } from '../assets/icons/bitBucket-icon.svg';
import {
  CodeRepos,
  ControlObject,
  FlattenedItem,
  RepoNode,
} from './onboarding-types';
import { toggleSingleSelection } from './actions/onboarding-repo-selection-actions';

export const codeRepoIconMap = new Map([
  [CodeRepos.AzureCode, AzureIcon],
  [CodeRepos.Bitbucket, BitbucketIcon],
  [CodeRepos.GitHub, GithubIcon],
  [CodeRepos.GitLab, GitlabIcon],
]);

export const AdvancedOptionsCheckboxesOptions = {
  [CodeRepos.GitHub]: [
    'repo',
    'read:packages',
    'write:org',
    'read:org',
    'read:repo_hook',
    'read:user',
    'user:email',
    'read:audit_log',
  ],
  [CodeRepos.GitLab]: ['api', 'read_user', 'read_registry'],
  [CodeRepos.AzureCode]: [
    'Work Items (Read)',
    'Code (Read)',
    'Build (Read)',
    'Release (Read)',
    'Test Management (Read)',
    'Packaging (Read)',
  ],
  [CodeRepos.Bitbucket]: [
    'Repositories (Read)',
    'Pull requests (Read)',
    'Webhooks',
  ],
};

export const createFlattenList = (
  treeData: RepoNode[],
  controlObject: ControlObject,
  parents: string[],
  indeterminateState = {},
) => {
  return treeData.reduce((flattenedTree, node) => {
    const deepness = parents.length;
    let selectedChildrenCount = 0;
    let indeterminateChildrenCount = 0;
    node.children.forEach(child => {
      selectedChildrenCount += controlObject[child.id]?.selected ? 1 : 0;
      indeterminateChildrenCount += indeterminateState[child.id] ? 1 : 0;
    });

    const isIndeterminate =
      indeterminateChildrenCount > 0 ||
      (selectedChildrenCount !== 0 &&
        selectedChildrenCount < node.children.length);

    const nodeWithHelpers = {
      ...node,
      deepness,
      parents,
      ...controlObject[node.id],
      isIndeterminate,
    };
    indeterminateState[node.id] = isIndeterminate;

    if (!node.children?.length || !controlObject[node.id]?.expanded) {
      return [...flattenedTree, nodeWithHelpers];
    }
    if (
      controlObject[node.id].selected !==
      (selectedChildrenCount === node.children.length)
    ) {
      toggleSingleSelection(
        node.id,
        selectedChildrenCount === node.children.length,
      );
    }

    return [
      ...flattenedTree,
      nodeWithHelpers,
      ...createFlattenList(
        node.children,
        controlObject,
        [...parents, node.id],
        indeterminateState,
      ),
    ];
  }, [] as FlattenedItem[]);
};
